const ChatIcon = () => (
    <svg
        height="1em"
        preserveAspectRatio="xMidYMid meet"
        version="1.0"
        viewBox="0 0 100.000000 100.000000"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="#000000" stroke="none" transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)">
            <path
                d="M399 867 c-104 -30 -199 -112 -247 -215 -23 -49 -27 -70 -27 -152 0
-87 3 -101 32 -161 39 -80 111 -150 191 -187 49 -23 70 -27 152 -27 87 0 101
3 161 32 80 39 150 111 187 191 23 49 27 70 27 152 0 82 -4 103 -27 152 -36
79 -108 152 -183 189 -74 36 -189 48 -266 26z m296 -202 c24 -23 25 -30 25
-140 0 -115 0 -117 -29 -146 -26 -25 -37 -29 -88 -29 -57 0 -58 -1 -105 -52
l-47 -53 -1 53 0 52 -44 0 c-105 0 -130 38 -124 191 3 87 6 100 27 123 24 26
25 26 193 26 166 0 169 0 193 -25z"
            />
            <path
                d="M320 660 c-18 -18 -20 -33 -20 -139 0 -117 1 -120 26 -140 20 -16 41
-21 85 -21 l59 0 0 -37 1 -38 32 36 c30 34 37 37 100 41 97 6 101 13 105 153
4 111 3 115 -22 140 -25 25 -27 25 -186 25 -147 0 -162 -2 -180 -20z"
            />
        </g>
    </svg>
);

export default ChatIcon;
